import React from 'react';
import { ExternalLink } from 'lucide-react';
import FadeIn from '../components/FadeIn';
import { exhibitions as years } from '../data/site';

const ExhibitionEvent = ({ event }) => (
  <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10" data-testid={`exhibition-${event.id}`}>
    {event.image && (
      <div className="lg:col-span-5">
        <div className="relative overflow-hidden aspect-[16/10] bg-[#f7f7f7]">
          <img src={event.image} alt={event.title} className="w-full h-full object-cover hover:scale-[1.02] transition-transform duration-[1.2s] ease-out" />
        </div>
      </div>
    )}
    <div className={`${event.image ? 'lg:col-span-7' : 'lg:col-span-12'} flex flex-col justify-center`}>
      <h3 className="text-[15px] md:text-[17px] font-medium text-[#1a1a1a] tracking-[0.01em]">{event.title}</h3>
      {event.subtitle && <p className="text-[13px] text-[#888] mt-1.5">{event.subtitle}</p>}
      <div className="mt-4 space-y-1">
        <p className="text-[12px] text-[#aaa]">{event.date}</p>
        <p className="text-[12px] text-[#aaa]">{event.location}</p>
      </div>
      {event.description && <p className="text-[13px] leading-relaxed text-[#888] mt-4 max-w-lg">{event.description}</p>}
      {event.link && (
        <a href={event.link} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 mt-5 text-[12px] text-[#999] hover:text-[#1a1a1a] transition-colors duration-300">
          Learn more <ExternalLink size={11} />
        </a>
      )}
    </div>
  </div>
);

const Exhibitions = () => {
  return (
    <div data-testid="exhibitions-page">
      <section className="max-w-[1400px] mx-auto px-6 md:px-12 pt-12 md:pt-20 pb-10">
        <FadeIn>
          <h1 className="text-xl md:text-3xl font-light text-[#1a1a1a] tracking-[0.01em]">Exhibitions</h1>
          <div className="w-10 h-px bg-[#ddd] mt-5" />
        </FadeIn>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-12 pb-20">
        <div className="space-y-20">
          {years.map((yearGroup) => (
            <FadeIn key={yearGroup.year}>
              <div>
                <div className="flex items-center gap-6 mb-10">
                  <span className="text-4xl md:text-5xl font-light text-[#e5e5e5] select-none">{yearGroup.year}</span>
                  <div className="h-px flex-1 bg-[#f0f0f0]" />
                </div>
                <div className="space-y-14">
                  {yearGroup.events.map((event) => (
                    <ExhibitionEvent key={event.id} event={event} />
                  ))}
                </div>
              </div>
            </FadeIn>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Exhibitions;
